/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ResultRange } from './ResultRange';
import {
    ResultRangeFromJSON,
    ResultRangeFromJSONTyped,
    ResultRangeToJSON,
} from './ResultRange';
import type { PamVerificationSummary } from './PamVerificationSummary';
import {
    PamVerificationSummaryFromJSON,
    PamVerificationSummaryFromJSONTyped,
    PamVerificationSummaryToJSON,
} from './PamVerificationSummary';
import type { PageSort } from './PageSort';
import {
    PageSortFromJSON,
    PageSortFromJSONTyped,
    PageSortToJSON,
} from './PageSort';

/**
 * 
 * @export
 * @interface PagePamVerificationSummary
 */
export interface PagePamVerificationSummary {
    /**
     * 
     * @type {Array<PamVerificationSummary>}
     * @memberof PagePamVerificationSummary
     */
    results: Array<PamVerificationSummary>;
    /**
     * 
     * @type {number}
     * @memberof PagePamVerificationSummary
     */
    totalResults: number;
    /**
     * 
     * @type {PageSort}
     * @memberof PagePamVerificationSummary
     */
    sort: PageSort;
    /**
     * 
     * @type {ResultRange}
     * @memberof PagePamVerificationSummary
     */
    resultRange: ResultRange;
}

/**
 * Check if a given object implements the PagePamVerificationSummary interface.
 */
export function instanceOfPagePamVerificationSummary(value: object): value is PagePamVerificationSummary {
    if (!('results' in value) || value['results'] === undefined) return false;
    if (!('totalResults' in value) || value['totalResults'] === undefined) return false;
    if (!('sort' in value) || value['sort'] === undefined) return false;
    if (!('resultRange' in value) || value['resultRange'] === undefined) return false;
    return true;
}

export function PagePamVerificationSummaryFromJSON(json: any): PagePamVerificationSummary {
    return PagePamVerificationSummaryFromJSONTyped(json, false);
}

export function PagePamVerificationSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): PagePamVerificationSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'results': ((json['results'] as Array<any>).map(PamVerificationSummaryFromJSON)),
        'totalResults': json['totalResults'],
        'sort': PageSortFromJSON(json['sort']),
        'resultRange': ResultRangeFromJSON(json['resultRange']),
    };
}

export function PagePamVerificationSummaryToJSON(value?: PagePamVerificationSummary | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'results': ((value['results'] as Array<any>).map(PamVerificationSummaryToJSON)),
        'totalResults': value['totalResults'],
        'sort': PageSortToJSON(value['sort']),
        'resultRange': ResultRangeToJSON(value['resultRange']),
    };
}

